import { connect } from 'react-redux';
import { loginUser } from '../actions';
import LoginForm from '../components/LoginForm';


const mapStateToProps = state => ({
  route: state.route,
  loginuser: state.loginStatus.loginuser,
  surname: state.loginStatus.surname,
  isFailure: state.loginStatus.isFailure
});

const mapDispatchToProps = dispatch => ({
  onChangeClick: (username, surname, rememberMe) => {
    dispatch(loginUser(username, surname, rememberMe));
  }
});


export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);



/** WEBPACK FOOTER **
 ** ./src/containers/loginContainer.jsx
 **/